import { useEffect } from 'react';
/**
 * custom hook in order to watch given html element and
 * check if user click outside it
 *
 * @param {refType} ref html element to watch focus
 * @param {callbackFunction} callback callback function to fired when clicked/touched away
 *
 */
const useClickAway = (ref, callback) => {
    useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            callback(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, callback]);
};
export default useClickAway;
